import { Component } from 'react';
import { string, shape } from 'prop-types';
import h from 'react-hyperscript';
import { NavLink, Link } from 'react-router-dom';

import Aux from '../Aux/Aux';
import { routeMap } from '../../routes';
import {
  hasVolunteerAdminAccess,
  hasCorpUserAccess,
  isSuperAdmin,
  isCorpAdmin,
  isVolunteerAdmin,
  isVolunteerUser,
} from '../../lib/authorization';

class Sidebar extends Component {
  static handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1
      ? 'nav-item nav-dropdown open'
      : 'nav-item nav-dropdown';
  }

  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }

  render() {
    const { profile = {}, me, venue } = this.props;

    const renderNavLink = (to, icon, text) =>
      h('li.nav-item', [
        h(NavLink, { to, className: 'nav-link', activeClassName: 'active' }, [
          h(`i.${icon.split(' ').join('.')}`),
          text,
        ]),
      ]);

    const renderTeaser = () =>
      h('li.nav-item.px-3.hidden-cn', [
        h('small', [h('b.text-uppercase', 'Subscription ended')]),
        h('.progress.progress-xs', [h('.progress-bar.bg-danger', { style: { width: '85%' } })]),
        h('small.text-muted', "Well that's no good. "),
        h(Link, { to: routeMap.USER_SETTINGS_SUBSCRIPTION.path, className: 'small' }, 'Fix it now.'),
      ]);

    const renderAdministrationItems = () => {
      const isSA = isSuperAdmin(profile);
      const isCA = isCorpAdmin(profile);
      const isVA = isVolunteerAdmin(profile);
      const isVU = isVolunteerUser(profile);

      if (isVU) {
        return [
          h('li.nav-title', 'Administration'),
          renderNavLink(routeMap.USER_SETTINGS.path, 'fa fa-user', routeMap.USER_SETTINGS.name),
        ];
      }

      if (isVA) {
        let npoId = (me && me.npo && me.npo.id) || null;

        if (!npoId && venue) {
          if (me && me.npos) {
            const npo = me.npos.find(n => n.venueId === venue.id);

            if (npo) {
              npoId = npo.id;
            }
          }
        }

        const npoUri = npoId ? routeMap.ORGANIZATIONS_ID.path.replace(/\/[:]id/i, `/${npoId}`) : '#';

        return [
          h('li.nav-title', 'Administration'),
          renderNavLink(npoUri, 'fa fa-group', routeMap.ORGANIZATIONS_ID.name),
        ];
      }

      if (isCA || isSA) {
        return [
          isSA && h('li.nav-title', 'Administration'),
          isSA && renderNavLink(routeMap.VENUES.path, 'fa fa-institution', routeMap.VENUES.name),
          h('li.nav-title', 'Venue'),
          // renderNavLink(routeMap.VENUE_SETTINGS.path, 'fa fa-cog', routeMap.VENUE_SETTINGS.name),
          renderNavLink(routeMap.VENUE_LOCATIONS.path, 'fa fa-map-marker', routeMap.VENUE_LOCATIONS.name),
        ];
      }

      return [''];
    };

    const renderEventsItems = () => [
      h('li.nav-title', 'Events'),
      renderNavLink(routeMap.EVENTS.path, 'fa fa-calendar', routeMap.EVENTS.name),
    ];

    const renderVolunteerAdminItems = () => {
      const isVA = isVolunteerAdmin(profile);
      const hasCUAccess = hasCorpUserAccess(profile);

      return hasCUAccess || isVA
        ? [
            !isVA &&
              h(Aux, [
                h('li.nav-title', 'Organizations'),
                renderNavLink(routeMap.ORGANIZATIONS.path, 'fa fa-group', 'Organizations'),
              ]),

            h('li.nav-title', 'Workers'),
            renderNavLink(routeMap.VOLUNTEERS.path, 'icon-people', routeMap.VOLUNTEERS.name),
          ]
        : [''];
    };

    const renderReportItems = () => {
      const hasVAAccess = hasVolunteerAdminAccess(profile);

      if (hasVAAccess) {
        return [
          h('li.nav-title', 'Reporting & Analytics'),
          renderNavLink(routeMap.REPORTS_EVENTS.path, 'fa fa-pie-chart', routeMap.REPORTS_EVENTS.name),
        ];
      }

      return [''];
    };

    return h('.sidebar', [
      h('.sidebar-nav', [
        h('ul.nav', [
          h('li.nav-title', 'Home'),
          renderNavLink(routeMap.DASHBOARD.path, 'icon-speedometer', 'Dashboard'),
          ...renderAdministrationItems(),
          ...renderEventsItems(),
          ...renderVolunteerAdminItems(),
          ...renderReportItems(),
          false && h(Aux, [h('li.nav-title', "What's New"), renderTeaser()]),
        ]),
      ]),
    ]);
  }
}

Sidebar.defaultProps = {
  location: {
    pathname: '',
  },
  profile: {},
  me: {},
  venue: {
    selected: null,
  },
};

Sidebar.propTypes = {
  location: shape({
    pathname: string.isRequired,
  }),
  me: shape({}),
  profile: shape({
    authorization: shape({}),
  }),
  venue: shape({}),
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js